// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"CreateLeaderboardPage_pageContainer__33ITP","icons":"CreateLeaderboardPage_icons__HnQti","formRow":"CreateLeaderboardPage_formRow__kBmb3"};